import React from "react";
import { AppContext } from "../app/AppContext.tsx";

export const useAuthService = () => {
  const { authService } = React.useContext(AppContext);
  if (!authService) {
    throw new Error("AuthService is not available in the AppContext");
  }
  return authService;
};
